declare global {
    interface Window {
        ym?: (id: number, type: string, goal: string, data?: Record<string, any>) => void;
        ymCounter: number; // счетчик яндекс метрики. Глобальная переменная объявляется в скрипте подключения яндекс метрики (GTM).
    }
}

export enum DEVICE_PERMISSION {
    ENABLED = 1,
    DISABLED = 0,
}

/** https://www.notion.so/trendtech/6c63afdb902c44989f483893f18d5122?v=fba86c7044f247f899d17796088fae10 */
export enum GoalType {
    AUTH_PAGE_AGREEMENT = 'meetings_auth_page_click_permission_check',
    AUTH_PAGE_JOIN = 'meetings_auth_page_click_join_button',
    AUTH_PAGE_VIEW = 'meetings_auth_page_view_page',
    CONFERENCE_PAGE_CAM = 'meetings_meeting_call_page_click_camera',
    CONFERENCE_PAGE_CAM_PERMISSION = 'meetings_meeting_call_page_view_info_add_permission',
    CONFERENCE_PAGE_CAM_PERMISSION_SUCCESS = 'meetings_meeting_call_page_view_success_camera',
    CONFERENCE_PAGE_EXIT = 'meetings_meeting_call_page_click_exit_button',
    CONFERENCE_PAGE_EXIT_CONFIRMATION = 'meetings_meeting_call_page_view_exit_popup',
    CONFERENCE_PAGE_EXIT_CONFIRMATION_ACCEPT = 'meetings_meeting_call_page_click_exit_button_on_popup',
    CONFERENCE_PAGE_EXIT_CONFIRMATION_CLOSE = 'meetings_meeting_call_page_click_close_button_on_popup',
    CONFERENCE_PAGE_EXTEND = 'meetings_meeting_call_page_view_extend_conferences_popup',
    CONFERENCE_PAGE_EXTEND_ACCEPT = 'meetings_meeting_call_page_click_extend_conferences_button',
    CONFERENCE_PAGE_EXTEND_CLOSE = 'meetings_meeting_call_page_click_close_extend_conferences_button',
    CONFERENCE_PAGE_INVITE = 'meetings_meeting_call_page_click_invite_button',
    CONFERENCE_PAGE_MIC = 'meetings_meeting_call_page_click_mic',
    CONFERENCE_PAGE_SCREEN_SHARE_END = 'meetings_meeting_call_page_click_screen_sharing_stop',
    CONFERENCE_PAGE_SCREEN_SHARE_START = 'meetings_meeting_call_page_click_screen_sharing',
    CONFERENCE_PAGE_TIMER = 'meetings_meeting_call_page_click_timer',
    CONFERENCE_PAGE_VIEW = 'meetings_meeting_call_page_view_page',
    DEV = 'dev',
    DEVICE_PERMISSION_DENIED_PAGE_CLOSE = 'meetings_settings_permission_page_close_info_add_permission',
    DEVICE_PERMISSION_DENIED_PAGE_VIEW = 'meetings_settings_permission_page_view_info_add_permission',
    PREPARATION_PAGE_CAM_PERMISSION = 'meetings_settings_permission_page_click_permission_camera_button',
    PREPARATION_PAGE_CAM_PERMISSION_SUCCESS = 'meetings_settings_permission_page_view_success_camera',
    PREPARATION_PAGE_JOIN = 'meetings_settings_permission_page_click_join_meeting_button',
    PREPARATION_PAGE_MIC_PERMISSION = 'meetings_settings_permission_page_click_permission_mic_button',
    PREPARATION_PAGE_MIC_PERMISSION_SUCCESS = 'meetings_settings_permission_page_view_success_mic',
    PREPARATION_PAGE_VIEW = 'meetings_settings_permission_page_view_page',
    RECORD_PAGE_VIEW = 'meetings_meeting_record_page_view',
}
